/*
 * @Author: DY
 * @Date: 2020-06-21 18:58:13
 * @LastEditTime: 2020-06-29 11:57:57
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \JiYun_Mobile\src\store\index.js
 */
import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export default new Vuex.Store({
    state: {
        orgData: [], // 顶部下拉组织数据
        isAddRouter: false, // 是否已添加路由表
        unreadMsg: 0, // 顶部未读消息数
        // 缓存组件
        keepAlive: [],
        // 缓存组件滚动条高度
        scrollTop: [0, 0, 0, 0, 0, 0],
        // 版本标识[1普通版本，2高级版]
        versionMark: '1',
    },
    mutations: {
        // 设置 下拉组织数据
        setOrgData(state, data) {
            state.orgData = data;
        },
        // 设置 是否已添加路由表
        setRouter(state, data) {
            state.isAddRouter = data;
        },
        // 设置 顶部消息数
        setUnreadMsg(state, data) {
            state.unreadMsg = data;
        },
        // 添加缓存组件
        setKeepAlive(state, component) {
            !state.keepAlive.includes(component) && state.keepAlive.push(component);
        },
        // 删除缓存组件
        noKeepAlive(state, component) {
            const index = state.keepAlive.indexOf(component);
            index !== -1 && state.keepAlive.splice(index, 1);
        },
        // 添加缓存组件滚动条高度
        recordScroll(state, data) {
            state.scrollTop[data.index] = data.top;
        },
        // 删除缓存组件滚动条高度
        deleteScroll(state) {
            state.scrollTop = [0, 0, 0, 0, 0, 0];
        },
        // 设置登录用户版本
        setVersionMark(state, data) {
            state.versionMark = data;
        },
    },
    actions: {},
    modules: {},
    getters: {
        keepAlive: state => state.keepAlive,
    },
});
